var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 48.214,
    viewBox: "0 0 50 48.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0.236 -0.474)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 25,
    cy: 24.107,
    rx: 25,
    ry: 24.107,
    transform: "translate(-0.236 0.474)",
    fill: "#004494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M272.041,147.556a15.182,15.182,0,0,1-4.7,1.423,8.959,8.959,0,0,0,3.6-5,15.473,15.473,0,0,1-5.2,2.192,7.844,7.844,0,0,0-5.979-2.851c-4.522,0-8.189,4.043-8.189,9.032a10.032,10.032,0,0,0,.211,2.059,22.618,22.618,0,0,1-16.882-9.437,9.705,9.705,0,0,0-1.109,4.541,9.3,9.3,0,0,0,3.643,7.517,7.582,7.582,0,0,1-3.71-1.129v.114a8.862,8.862,0,0,0,6.57,8.856,7.437,7.437,0,0,1-2.158.317,7.562,7.562,0,0,1-1.542-.159,8.347,8.347,0,0,0,7.65,6.272,15.489,15.489,0,0,1-10.171,3.868,14.833,14.833,0,0,1-1.955-.129,21.642,21.642,0,0,0,12.555,4.06c15.065,0,23.3-13.763,23.3-25.7q0-.588-.025-1.168A17.741,17.741,0,0,0,272.041,147.556Z",
    transform: "translate(-227.104 -136.628)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5551e8fdc782494512d75e427d47a8c0.svg";
export { ForwardRef as ReactComponent };